export default {
  GetTaxcodeList(state) {
    return state.taxcodeList;
  },
  GetTaxcodeListMeta(state) {
    return state.taxcodeListMeta;
  },
  GetTaxcodeObject(state) {
    return state.currentTaxcodeObject;
  }
};
